import React, {useCallback} from "react";
import "./index.scss";
import {LoggedInLayout} from "features/layouts/pages/logged-in";
import Title from "features/components/title";
import {__} from "services/i18n";
import Button from "features/components/button";
import {historyObject} from "historyObject";
import Text from "features/components/text";
import {PRIVACY_POLICY_URL} from "constants.js";
import {connect} from "react-redux";
import DeleteAccountModal from "features/modals/delete-account";
import {deleteAccountSetShow} from "features/modals/delete-account/reducer";
import {deleteAccountShowModal} from "features/modals/delete-account/selectors";

/* istanbul ignore next */
const mapStateToProps = state => ({
    show_delete_modal: deleteAccountShowModal(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    deleteAccountSetShow
};

export const PrivacyPage = (props) => {
    const {deleteAccountSetShow, show_delete_modal} = props;
    const openDeleteModal = useCallback(() => {
        deleteAccountSetShow(true)
    }, [deleteAccountSetShow]);

    return <LoggedInLayout
        type={"light"}
        className={"privacy-page"}
        breadcrumbs={[{title: "common.home-breadcrumb", link:"/"}, {title: "common.personal-area"}, {title: "privacy.breadcrumb"}, {title: "..."}]}>
        <div className={"sidebar-wrapper"}>
            <div className="sidebar">
                <Title size={34}>{__("privacy.title")}</Title>
                <Button title={""} onClick={() => historyObject.goBack()} type={"square"} icon={"arrow-left"} />
            </div>
            <div className="content">
                <div className="white-box">
                    <div>
                        <Title size={18}>{__("privacy.info.title")}</Title>
                        <Text size={16}>{__("privacy.info.text")}</Text>
                        <Button title={__("privacy.info.button")} onClick={() => window.open(PRIVACY_POLICY_URL, "_blank")} type={"outlined"} />
                    </div>
                    <div>
                        <Title size={18}>{__("privacy.data.title")}</Title>
                        <Text size={16}>{__("privacy.data.text")}</Text>
                    </div>
                    <div>
                        <Title size={18}>{__("privacy.rights.title")}</Title>
                        <Text size={16}>{__("privacy.rights.text")}</Text>
                    </div>
                    <div>
                        <Title className="delete" size={18}>{__("privacy.delete.title")}</Title>
                        <Text size={16}>{__("privacy.delete.text")}</Text>
                        <div className="delete-account-button" onClick={openDeleteModal}>
                            <Text size={16}>{__("privacy.delete.button")}</Text>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {show_delete_modal && <DeleteAccountModal/>}
    </LoggedInLayout>
};
export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPage);